import {useState} from 'react'
import Axios from 'axios'
import { useTranslation } from "react-i18next"
import Swal from 'sweetalert2'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
// import ChangeLanguage from '../../translations/ChangeLanguage'

/**
 * 
 * @returns 
 */
export const Forgot = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    
    /**
     * Comprueba los datos del formulario
     * @param {*} e evento
     */
    const handleSubmit = async (e) => {
        e.preventDefault()
        // Obtenemos el mail del usuario
        const clientEmail = e.target.email.value

        setIsLoading(true)
        
        // Enviamos la petición al /forgotpassword con el email
        await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/forgot/sendmailrecovery', {email: clientEmail})
            .then((res) => {
                setIsLoading(false)
                navigate('/emailsend/'+clientEmail)
            }).catch((err) => {
                setIsLoading(false)
                // Mostramos el popup informativo
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'error',
                    text: t('forgot.sendError')
                })
            })
    } 
    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="text-center mb-4">
                    <img src="/images/logo-inicio.png" alt="logotipo" height={40} />
                </div>
                <div className="login-title">{t('forgot.question')}</div>
                <div className="login-subtitle">{t('forgot.help1')}<br/>{t('forgot.help2')}</div>

                <Form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <Form.Label>{t('forgot.email')}</Form.Label>
                        <Form.Control
                            placeholder={t('forgot.email')}
                            name="email"
                            type="email"
                            autoComplete="off"
                        />
                    </div>

                    <Button variant="primary" type="submit" className="w-100" disabled={isLoading}>
                        {isLoading ? (
                            <span className="spinner-border spinner-border-sm align-middle"></span>
                        ) : (
                            t('forgot.submit')
                        )}
                    </Button>

                    <div className="text-center mt-4">
                        <Link className="btn btn-secondary" to="/login">
                            <i className="fas fa-chevron-left"></i> {t('global.return')}
                        </Link>
                    </div>
                </Form>
            </div>
        </div>
    )    
}
